// extracted by mini-css-extract-plugin
export default {"notify":"ResponseWarning_notify__hyjgv","text":"ResponseWarning_text__Sq1DF","icon":"ResponseWarning_icon__ytsQb"};